var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67715 10.3039L10.8657 15.4769C11.0052 15.7036 11.2232 15.701 11.3113 15.6888C11.3993 15.6766 11.6112 15.6225 11.6879 15.3653L15.6752 1.89861C15.745 1.66058 15.6168 1.49841 15.5592 1.44086C15.5034 1.38331 15.3439 1.26037 15.1128 1.32577L1.63653 5.27204C1.38106 5.34703 1.32526 5.56152 1.31305 5.64958C1.30085 5.73939 1.29736 5.96173 1.52318 6.10385L6.75553 9.37614L11.3784 4.70443C11.6321 4.44809 12.0463 4.44547 12.3035 4.6992C12.5607 4.95292 12.5625 5.36796 12.3087 5.6243L7.67715 10.3039ZM11.2433 17.0019C10.6364 17.0019 10.0801 16.6932 9.7523 16.1631L6.37189 10.6779L0.830013 7.21205C0.232753 6.838 -0.0793921 6.17186 0.0173903 5.47171C0.113301 4.77157 0.593725 4.21529 1.26859 4.01736L14.7449 0.0710849C15.3648 -0.110273 16.0292 0.0614938 16.4861 0.516632C16.943 0.97613 17.113 1.6475 16.9281 2.27005L12.9409 15.7359C12.7412 16.4133 12.1832 16.892 11.4848 16.9853C11.4028 16.9958 11.3235 17.0019 11.2433 17.0019Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconWhite);
export default __webpack_public_path__ + "static/media/sendIconWhite.1e698c7aa98d583790cf4e6f44f7773c.svg";
export { ForwardRef as ReactComponent };